import { render, staticRenderFns } from "./EndPayment.vue?vue&type=template&id=3280975f&"
import script from "./EndPayment.vue?vue&type=script&lang=js&"
export * from "./EndPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports